import { useCallback } from 'react';
import { IExtrasFormData } from '../IExtrasFormData';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { trackRemoveAncillaries } from '../../shared/analytics/e-commerce/trackRemoveAncillaries';
import { trackSelectAncillaries } from '../../shared/analytics/e-commerce/trackSelectAncillaries';
import { useNavigate } from '../../../../../shared/router/useNavigate';

export function useExtrasSubmit(nextUrl: string) {
	const newBookingStore = useNewBookingStore();
	const navigate = useNavigate();

	return useCallback(
		(data: IExtrasFormData) => {
			if (newBookingStore.booking.ancillaries.length) {
				trackRemoveAncillaries(newBookingStore.booking.ancillaries);
			}

			newBookingStore.selectAncillaries(data.ancillaryGroups ?? []);

			trackSelectAncillaries(newBookingStore.booking.ancillaries);

			navigate(nextUrl);
		},
		[nextUrl],
	);
}
